export default __webpack_public_path__ + "static/media/Bracers of Rapturous Battle.49731cd2.jpg";